import React from 'react'
import { Box } from '@mui/material'

export type TAuthPageProps = {
  children: React.ReactChild
}

export const AuthPage: React.FC<TAuthPageProps> = ({ children }): JSX.Element => {
  return (
    <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
      <Box marginTop={16.875}>{children}</Box>
    </Box>
  )
}
